<template>
  <div class="layout-common-menu-card">
    <CardHeader @showMenuDialog="showMenuDialog" @showGroupDialog="showGroupDialog" />
    <CommonModuleList ref="groupTabBox" @menu-group-change="onMenuGroupChange" />
    <el-dialog v-bind="dialogOption"
               :view.sync="dialogOption.view"
               :custom-class="layoutDialogClass"
               :append-to-body="false"
               class="kye-dialog__modal-in-tab"
               :close-on-click-modal="false"
               :modal-append-to-body="false"
               :showFullScreenButton="false"
               :canResize="false"
               @close="closeDialog"
               :visible.sync="dialogOption.show">
      <component :is="dialogOption.view"
                 ref="component"
                 :menuGroup="curMenuGroup"
                 @update="refresh"
                 @close="closeDialog"></component>
    </el-dialog>
  </div>
</template>

<script>
import dialogMixins from '../dialog'
// 卡片头部
import CardHeader from './card-header.vue'
// 分组 tab 与模块列表
import CommonModuleList from '@/layout/components/common-module-list/index.vue'
// 添加常用弹窗
import AddMenuDialog from './add-menu-dialog'
// 分组管理弹窗
import MenuGroupDialog from './menu-group-dialog'

export default {
  mixins: [dialogMixins],
  components: { CardHeader, CommonModuleList, AddMenuDialog, MenuGroupDialog },
  data() {
    return {
      curMenuGroup: {
        moduleGroupId: '',
        moduleGroupName: ''
      },
      layoutDialogClass: ''
    }
  },
  mounted () {
    this.$bus.$on('APP_LOADED', this.init)
  },
  activated () {
    this.init()
  },
  beforeDestroy () {
    this.$bus.$off('APP_LOADED', this.init)
  },
  methods: {
    showMenuDialog () {
      this.layoutDialogClass = 'layout-add-menu-dialog kye-dialog-dynamic'
      this.showDialog('AddMenuDialog', '', '1150px')
      this.$refs.component && this.$refs.component.onOpen()
    },
    showGroupDialog () {
      this.layoutDialogClass = 'layout-menu-group-dialog kye-dialog-dynamic'
      this.showDialog('MenuGroupDialog', '', '1146px')
      this.$refs.component && this.$refs.component.init()
    },
    onMenuGroupChange (val) {
      this.curMenuGroup = val
    },
    refresh () {
      this.$bus.$emit('GLOABL_HOME_UPDATE_MENU')
    },
    init () {
      this.$refs.groupTabBox && this.$refs.groupTabBox.init()
    },
  }
}
</script>

<style lang="scss">
.layout-common-menu-card {
  border-radius: 12px;
  // background: rgba(255, 255, 255, 0.7);
  background: #ffffff;
  width: 100%;
  overflow-y: auto;
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 8px 16px 0;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.06);
}
.layout-add-menu-dialog {
  border-radius: 16px !important;
  .el-dialog__header {
    width: 929px;
    position: absolute;
    right: 0;
    top: 0;
    height: 40px;
    padding-left: 0px;
    border-bottom: none;
    .el-dialog__title {
      line-height: 36px;
    }
  }
  .el-dialog__body {
    padding-top: 40px !important;
    border-bottom-left-radius: 16px !important;
    border-bottom-right-radius: 16px !important;
  }
  .el-dialog__footer {
    border-top: none;
  }
}

.el-dialog__wrapper:has(> .layout-add-menu-dialog) + .v-modal{
  left: var(--menu-width);
  top: 78px;
}
.layout-menu-group-dialog {
  border-radius: 16px !important;
  >.el-dialog__header {
    //width: 929px;
    //position: absolute;
    //right: 0;
    //top: 0;
    //height: 60px;
    //padding-left: 0;
    border-bottom: none;
    .el-dialog__title {
      //line-height: 36px;
    }
  }
  //>.el-dialog__body {
  //  padding-top: 60px !important;
  //}
  //>.el-dialog__footer {
  //  border-top: none;
  //}
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/index.vue